<template>
  <div :id="navId" class="article-display-image-text-container container">
    <div class="article-display-image-text">
      <div class="left">
        <div class="textBox__wrapper">
          <div class="textBox">
            <div v-if="subHeading" class="article-display-image-text__type">
              {{ subHeading }}
            </div>
            <div v-if="heading" class="heading">{{ heading }}</div>
            <div class="text"><slot name="content" /></div>
          </div>
        </div>
        <div class="single-image">
          <Picture :images="imageTwo" />
        </div>
      </div>
      <div class="right">
        <div class="single-image">
          <AddFromVideo
            v-if="videoUrl"
            :product-handle="productHandle"
            :video-url="videoUrl"
          />
          <IntersectionObserver v-if="videoUrl2" v-slot="{ intersected }">
            <Video
              :intersected="intersected"
              :video="{
                sources: [
                  {
                    url: videoUrl2,
                  },
                ],
              }"
            />
          </IntersectionObserver>
          <Picture :images="imageOne" />
        </div>
        <div class="two-images">
          <Picture :images="imageThree" />
          <Picture :images="imageFour" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import AddFromVideo from "@/components/AddFromVideo.vue";
import Video from "@/components/Video.vue";
import IntersectionObserver from "@/components/IntersectionObserver.vue";
export default {
  name: "ArticleDisplayImageText",
  components: {
    Picture,
    AddFromVideo,
    Video,
    IntersectionObserver,
  },
  props: {
    navId: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    imageOne: {
      type: Object,
      default: null,
    },
    imageTwo: {
      type: Object,
      default: null,
    },
    imageThree: {
      type: Object,
      default: null,
    },
    imageFour: {
      type: Object,
      default: null,
    },
    videoUrl: {
      type: String,
      default: null,
    },
    videoUrl2: {
      type: String,
      default: null,
    },
    productHandle: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.article-display-image-text {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 60px;

  :deep(.picture__wrapper) {
    display: block;
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .textBox__wrapper {
      flex: 1 0 auto;
      display: flex;
      align-items: center;
      padding: 0 20%;
    }
  }

  .right {
    .single-image {
      margin-bottom: 20px;
    }
  }

  &__type {
    color: $color-grey-dark;
    @include t__utility-label-30;
    margin: 0 0 10px;
    text-align: center;
  }
}

.two-images {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px; //todo: add correct gap
}

:deep(h4) {
  margin-bottom: 10px;
}

.heading {
  @include t__editorial-headline-20;
  text-align: center;
  margin-bottom: 10px;
}

.text {
  text-align: center;
}

:slotted(p) {
  @include t__editorial-body-20;
  margin: 0 0 15px 0;
}
</style>
